/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {BulkProgress} from '../models/BulkProgress';
import type {Error} from '../models/Error';
import type {UpdateUserEntitlementsRelation} from '../models/UpdateUserEntitlementsRelation';
import type {UpdateUserEntitlementsResult} from '../models/UpdateUserEntitlementsResult';

export interface BulkAssignUserEntitlements$Request {
    updateUserEntitlementsRelation: UpdateUserEntitlementsRelation;
    reason?: string;
}

export interface BulkAssignUserEntitlements$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const bulkAssignUserEntitlementsRequest = createAction<PayloadData<void, BulkAssignUserEntitlements$Request>>('BULK_ASSIGN_USER_ENTITLEMENTS__BULK_ASSIGN_USER_ENTITLEMENTS__REQUEST');
export const bulkAssignUserEntitlementsSuccess = createAction<PayloadData<string, BulkAssignUserEntitlements$Request>>('BULK_ASSIGN_USER_ENTITLEMENTS__BULK_ASSIGN_USER_ENTITLEMENTS__SUCCESS');
export const bulkAssignUserEntitlementsFailure = createAction<PayloadData<Error, BulkAssignUserEntitlements$Request, true>>('BULK_ASSIGN_USER_ENTITLEMENTS__BULK_ASSIGN_USER_ENTITLEMENTS__FAILURE');

export const bulkAssignUserEntitlementsActions = [
    bulkAssignUserEntitlementsRequest,
    bulkAssignUserEntitlementsSuccess,
    bulkAssignUserEntitlementsFailure
] as const;

/**
 * @param {UpdateUserEntitlementsRelation} meta.updateUserEntitlementsRelation
 * @param {string} [meta.reason] Optional audit reason for this update. Blank values use the existing operation-specific reason.
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const bulkAssignUserEntitlements = (meta: BulkAssignUserEntitlements$Request, config?: BulkAssignUserEntitlements$Config) => {
    const TRANSPORT_GET_PARAMS = {
        reason: meta.reason,
    };
    return {
        CALL_API: {
            types: bulkAssignUserEntitlementsActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/users/entitlements/assign`,
            TRANSPORT_GET_PARAMS,
            TRANSPORT_REQUEST_BODY: meta.updateUserEntitlementsRelation,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetAssignUserEntitlementsProgress$Request {
    id: string;
}

export interface GetAssignUserEntitlementsProgress$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAssignUserEntitlementsProgressRequest = createAction<PayloadData<void, GetAssignUserEntitlementsProgress$Request>>('BULK_ASSIGN_USER_ENTITLEMENTS__GET_ASSIGN_USER_ENTITLEMENTS_PROGRESS__REQUEST');
export const getAssignUserEntitlementsProgressSuccess = createAction<PayloadData<BulkProgress, GetAssignUserEntitlementsProgress$Request>>('BULK_ASSIGN_USER_ENTITLEMENTS__GET_ASSIGN_USER_ENTITLEMENTS_PROGRESS__SUCCESS');
export const getAssignUserEntitlementsProgressFailure = createAction<PayloadData<Error, GetAssignUserEntitlementsProgress$Request, true>>('BULK_ASSIGN_USER_ENTITLEMENTS__GET_ASSIGN_USER_ENTITLEMENTS_PROGRESS__FAILURE');

export const getAssignUserEntitlementsProgressActions = [
    getAssignUserEntitlementsProgressRequest,
    getAssignUserEntitlementsProgressSuccess,
    getAssignUserEntitlementsProgressFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAssignUserEntitlementsProgress = (meta: GetAssignUserEntitlementsProgress$Request, config?: GetAssignUserEntitlementsProgress$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: getAssignUserEntitlementsProgressActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/users/entitlements/assign/progress`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetAssignUserEntitlementsResult$Request {
    id: string;
}

export interface GetAssignUserEntitlementsResult$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAssignUserEntitlementsResultRequest = createAction<PayloadData<void, GetAssignUserEntitlementsResult$Request>>('BULK_ASSIGN_USER_ENTITLEMENTS__GET_ASSIGN_USER_ENTITLEMENTS_RESULT__REQUEST');
export const getAssignUserEntitlementsResultSuccess = createAction<PayloadData<UpdateUserEntitlementsResult, GetAssignUserEntitlementsResult$Request>>('BULK_ASSIGN_USER_ENTITLEMENTS__GET_ASSIGN_USER_ENTITLEMENTS_RESULT__SUCCESS');
export const getAssignUserEntitlementsResultFailure = createAction<PayloadData<Error, GetAssignUserEntitlementsResult$Request, true>>('BULK_ASSIGN_USER_ENTITLEMENTS__GET_ASSIGN_USER_ENTITLEMENTS_RESULT__FAILURE');

export const getAssignUserEntitlementsResultActions = [
    getAssignUserEntitlementsResultRequest,
    getAssignUserEntitlementsResultSuccess,
    getAssignUserEntitlementsResultFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAssignUserEntitlementsResult = (meta: GetAssignUserEntitlementsResult$Request, config?: GetAssignUserEntitlementsResult$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: getAssignUserEntitlementsResultActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/users/entitlements/assign`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

